import React from "react";
import { useTranslation } from "react-i18next";
import Button from "@amzn/awsui-components-react/polaris/button";
import Container from "@amzn/awsui-components-react/polaris/container";
import Grid from "@amzn/awsui-components-react/polaris/grid";
import Header from "@amzn/awsui-components-react/polaris/header";
import Select from "@amzn/awsui-components-react/polaris/select";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import { useInsightsFilters } from "./hooks";
import {
  MONTHS_FILTER,
  YEARS_FILTER,
} from "features/calculate-taxes-table-filters/constants";
import { IInsightsFiltersProps } from "./interfaces";
import { MULTIPLE_STATE_ENTITY } from "components/upload-tax-file-modal/constants";

const getSelectedOption = (value: string) => ({ value, label: value });

const InsightsFilters: React.FC<IInsightsFiltersProps> = ({ onConfirm }) => {
  const { t } = useTranslation();
  const header = t("features.insights_filters.header");
  const {
    insightsFilters: { year, month, state, entity },
    updateYear,
    updateMonth,
    updateState,
    updateEntity,
  } = useInsightsFilters();

  return (
    <div data-testid="insights-filters">
      <Container>
        <SpaceBetween size="m" direction="vertical">
          <Header>{header}</Header>
          <Grid
            gridDefinition={[
              { colspan: 1.5 },
              { colspan: 1.5 },
              { colspan: 1.5 },
              { colspan: 1.5 },
            ]}
          >
            <div>
              <Select
                data-testid="insights-filters-year-select"
                selectedOption={getSelectedOption(year.toString())}
                placeholder="Year"
                filteringType="auto"
                options={YEARS_FILTER}
                onChange={(e) =>
                  updateYear(parseInt(e.detail.selectedOption.value!))
                }
              />
            </div>
            <div>
              <Select
                data-testid="insights-filters-month-select"
                selectedOption={getSelectedOption(month)}
                placeholder="Month"
                filteringType="auto"
                options={MONTHS_FILTER}
                onChange={(e) => updateMonth(e.detail.selectedOption.value!)}
              />
            </div>
            <div>
              <Select
                data-testid="insights-filters-state-select"
                selectedOption={getSelectedOption(state)}
                placeholder="State"
                filteringType="auto"
                onChange={(e) => updateState(e.detail.selectedOption.value!)}
                options={[getSelectedOption(MULTIPLE_STATE_ENTITY)]}
              />
            </div>
            <div>
              <Select
                data-testid="insights-filters-entity-select"
                selectedOption={getSelectedOption(entity)}
                placeholder="Entity"
                filteringType="auto"
                onChange={(e) => updateEntity(e.detail.selectedOption.value!)}
                options={[getSelectedOption(MULTIPLE_STATE_ENTITY)]}
              />
            </div>
            <div>
              <Button variant="primary" onClick={onConfirm}>
                {t("features.insights_filters.apply")}
              </Button>
            </div>
          </Grid>
        </SpaceBetween>
      </Container>
    </div>
  );
};

export default InsightsFilters;
